<div class="card item_card" [id]="configuration.id">
    <div class="card-body item_card_res d-inline-flex align-items-center" >
      <div class=" col-sx-2">
          <div [ngSwitch]="configuration.type">
              <span *ngSwitchCase ="'PMR'" class="fa-stack fa-2x parking-Icon" [title]="configuration.type">
                  <i class="fas fa-square fa-stack-2x "></i>
                  <i class="parking-type fa-stack-1x fas fa-wheelchair" style="color:white"></i>
              </span>
              <span *ngSwitchCase = "'Paying'" class="fa-stack fa-2x parking-Icon" [title]="configuration.type">
                  <i class="fas fa-square fa-stack-2x "></i>
                  <i class="parking-type fa-stack-1x fas fa-euro-sign" style="color:white"></i>
              </span>
              <span *ngSwitchCase = "'Private'" class="fa-stack fa-2x parking-Icon" [title]="configuration.type">
                  <i class="fas fa-square fa-stack-2x "></i>
                  <i class="parking-type fa-stack-1x fas fa-ban" style="color:red"></i>
              </span>
              <span *ngSwitchCase = "'Resident'" class="fa-stack fa-2x parking-Icon" [title]="configuration.type">
                  <i class="fas fa-square fa-stack-2x "></i>
                  <i class="parking-type fa-stack-1x fas fa-home" style="color:white"></i>
              </span>
              <span *ngSwitchCase = "'Delivering'" class="fa-stack fa-2x parking-Icon" [title]="configuration.type">
                  <i class="fas fa-square fa-stack-2x "></i>
                  <i class="parking-type fa-stack-1x fas fa-truck" style="color:white"></i>
              </span>
              <span *ngSwitchCase = "'Rescue'" class="fa-stack fa-2x parking-Icon" [title]="configuration.type">
                  <i class="fas fa-square fa-stack-2x "></i>
                  <i class="parking-type fa-stack-1x fas fa-ambulance" style="color:white"></i>
              </span>
              <span *ngSwitchDefault class="fa-stack fa-2x parking-Icon" [title]="configuration.type">
                  <i class="fas fa-square fa-stack-2x "></i>
                  <i class="parking-type fa-stack-1x faps fa-home" style="color:white"></i>
              </span>
          </div>

      </div>
      <div class="text_section flex-grow-1 col-sx-9">
        <div class="d-flex flex-column">
        <div class="card-title mb-auto">
            <div mat-card-avatar class="place-header-image bold14">
              <p>
                Label:<br>
                <span class="">{{configuration.label}}</span>
              </p>

            </div>
        </div>
        <div class="card-text">
            <p>Status:
                <span *ngIf="configuration.active" class="badge badge-secondary">Active</span>
                <span *ngIf="!configuration.active" class="badge badge-secondary">Inactive</span>
              </p>
            <div *ngIf="startDay || startTime" class="item_categorie">
                <p >
                    <span *ngIf="!startDay"> Tous les jours </span>
                    <span *ngIf="startDay">Du {{startDay}} </span>
                    <span *ngIf="startTime"> {{startTime}}</span>
                </p>
            </div>
            <div *ngIf="endDay || endTime" class="item_categorie">
                <p >
                    <span *ngIf="!endDay"> à </span>
                    <span *ngIf="endDay">Au {{endDay}} </span>
                    <span *ngIf="endTime"> {{endTime}}</span>
                </p>
            </div>
            <p class="item_categorie">
  <!-- date -->
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
        <p class="item_categorie">
            <button type="button" class="btn"  (click)="edit()"  [title]="'Editer les information'">
                <i class="fas fa-edit" ></i>
            </button>
            <button type="button" class="btn"  (click)="addPlaces()" [title]="'Editer la configuration'">
                <i class="fas fa-plus-square"></i>

            </button>
        </p>
    </div>
  </div>
